import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=741f54de&scoped=true&"
import script from "./PageLayout.vue?vue&type=script&lang=js&"
export * from "./PageLayout.vue?vue&type=script&lang=js&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=741f54de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741f54de",
  null
  
)

component.options.__file = "PageLayout.vue"
export default component.exports